import {
  LOCAL_STORAGE_KEY_ORDER_BY_FILA_ESPERA,
  LOCAL_STORAGE_KEY_ORDER_BY_ATENDIMENTOS_INICIADOS,
} from 'constants/localStorageKeys';

enum OrderByParamsEnum {
  UNANSWERED_IN_ASC = 'unansweredIn:asc',
  STARTED_IN_ASC = 'startedIn:asc',
  UNREAD_IN_DESC = 'unreadIn:desc',
}

const VALID_VALUES = Object.values(OrderByParamsEnum);

function resolveOrderBy(
  urlParams: URLSearchParams,
  urlParam: string,
  storageKey: string,
): OrderByParamsEnum | undefined {
  const fromUrl = urlParams.get(urlParam);
  if (fromUrl && VALID_VALUES.includes(fromUrl as OrderByParamsEnum)) {
    return fromUrl as OrderByParamsEnum;
  }

  const fromStorage = localStorage.getItem(storageKey);
  if (fromStorage && VALID_VALUES.includes(fromStorage as OrderByParamsEnum)) {
    return fromStorage as OrderByParamsEnum;
  }

  return undefined;
}

export function getUrlParams() {
  const urlParams = new URLSearchParams(window.location.search);

  return {
    orderBy: resolveOrderBy(
      urlParams,
      'orderBy',
      LOCAL_STORAGE_KEY_ORDER_BY_FILA_ESPERA,
    ),
    orderInitiatedBy: resolveOrderBy(
      urlParams,
      'orderInitiatedBy',
      LOCAL_STORAGE_KEY_ORDER_BY_ATENDIMENTOS_INICIADOS,
    ),
  };
}
